import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || undefined,
};

const hasMinimalConfig =
  Boolean(firebaseConfig.apiKey) && Boolean(firebaseConfig.projectId);

/** Instance Firebase Web ; null si la config n’est pas renseignée (.env). */
export const firebaseApp = hasMinimalConfig ? initializeApp(firebaseConfig) : null;

/** Auth web — null si Firebase n’est pas configuré */
export const firebaseAuth = firebaseApp ? getAuth(firebaseApp) : null;

/** Firestore client — null si Firebase n’est pas configuré */
export const firebaseDb = firebaseApp ? getFirestore(firebaseApp) : null;

/** Storage client — null si Firebase n’est pas configuré */
export const firebaseStorage = firebaseApp ? getStorage(firebaseApp) : null;

export const isFirebaseAuthConfigured = Boolean(firebaseAuth);

if (typeof window !== 'undefined' && firebaseApp) {
  isSupported()
    .then((ok) => {
      if (ok) {
        getAnalytics(firebaseApp);
      }
    })
    .catch(() => {});
}
